import { Injectable } from '@angular/core';
import { StrictBehavior } from '../../behavior';
import { BehaviorContext } from '../../behavior-context';
import {
  getElapsedTime,
  ANALYTICS_KEYS,
  pushToDataLayer,
  readVariableFromContext,
} from './util';

@Injectable()
export class TrackPageViewBehavior extends StrictBehavior {
  async executeBehavior(args: any, ctx: BehaviorContext): Promise<any> {
    const location = window.location.href;
    let page = location;
    if (location.indexOf('#') >= 0) {
      page = location.split('#')[1];
    }
    if (page.indexOf('?') >= 0) {
      page = page.split('?')[0];
    }

    pushToDataLayer({
      event: ANALYTICS_KEYS.VIRTUAL_PAGEVIEW,
      // 'title': sectionTitle,
      // 'page': page,
      // 'location': location,
      // 'storeId': this._storeId,
      // 'customerId': this._uiState.sessionId,
      // 'flowType': flowType,
      // 'flowName': flowName,
      // 'cartId': this._uiState.merchantCartId // TODO: get this added in GTM
    });
  }
}

/* 
{
  behaviorKey: 'TrackEvent',
  args: {
      eventCategory: 'eventTracker'
      eventAction: 'Application Submission',
      eventData: {
        'staticValue': 'one hundred',
        'someNumber': 100
      },
      eventVariables: {
        'payEstEngagements': 'estimatorEngagements'
      }
  }
}
*/

@Injectable()
export class TrackEventBehavior extends StrictBehavior {
  async executeBehavior(
    args: {
      eventCategory: string;
      eventAction: string;
      eventValue: any;
      eventNonInteraction: any;
      eventData: any;
      eventVariables: any;
    },
    ctx: BehaviorContext
  ): Promise<any> {
    const payload = {
      event: ANALYTICS_KEYS.EVENT_TRACKER,
      eventCategory: args.eventCategory,
      eventAction: args.eventAction,
      eventValue: args.eventValue || 0,
      eventNonInteraction: args.eventNonInteraction || 0,
    };

    if (args.eventData) {
      Object.keys(args.eventData).forEach(key => {
        payload[key] = args.eventData[key];
      });
    }
    if (args.eventVariables) {
      Object.keys(args.eventVariables).forEach(key => {
        payload[key] = readVariableFromContext(args.eventVariables[key], ctx);
      });
    }

    pushToDataLayer(payload);
  }
}

@Injectable()
export class StartTrackTimeBehavior extends StrictBehavior {
  async executeBehavior(
    args: { timeTrackerKey: string },
    ctx: BehaviorContext
  ): Promise<any> {
    ctx.set(args.timeTrackerKey, new Date());
  }
}
/* 

{
  behaviorKey: 'EndTrackTime',
  args: {
      timeTrackerKey: 'applicationSubmitTime',
      eventCategory: 'eventTracker'
      eventAction: 'Application Submission',
      eventValues: {
        'staticValue': 'one hundered',
        'someNumber': 100
      },
      eventVariables: {
        'payEstEngagements': 'estimatorEngagements'
      }
  }
}

*/

@Injectable()
export class EndTrackTimeBehavior extends StrictBehavior {
  async executeBehavior(
    args: {
      timeTrackerKey: string;
      eventCategory: string;
      eventAction: string;
      eventValue: any;
      eventNonInteraction: any;
      eventData: any;
      eventVariables: any;
    },
    ctx: BehaviorContext
  ): Promise<any> {
    const startTime = ctx.get(args.timeTrackerKey);
    const endTime = new Date();
    const duration = getElapsedTime(startTime, endTime);

    const payload = {
      event: ANALYTICS_KEYS.EVENT_TRACKER,
      eventCategory: args.eventCategory,
      eventAction: args.eventAction,
      eventValue: args.eventValue || 0,
      eventNonInteraction: args.eventNonInteraction || 0,
      [args.timeTrackerKey]: duration,
    };

    if (args.eventData) {
      Object.keys(args.eventData).forEach(key => {
        payload[key] = args.eventData[key];
      });
    }
    if (args.eventVariables) {
      Object.keys(args.eventVariables).forEach(key => {
        payload[key] = readVariableFromContext(args.eventVariables[key], ctx);
      });
    }

    pushToDataLayer(payload);
  }
}
